<template>
  <div style="transition: 0.4s; box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6); z-index: 999999;" class="w-1/4 flex-1 bg-white rounded-xl space-y-6 p-6" :class="`step${ nowStep }`">
    <p v-html="content"></p>
    <div class="tip-footer">
      <button
        :style="{ opacity: nowStep === 701 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep === 1"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
      <button
        v-if="nowStep === 735"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="next()"
      >
        {{finishText}}
      </button>
      <button
        v-else
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
        @click="next()"
      >
        {{nextText}}
      </button>

    </div>
  </div>
</template>

<script>
import * as contentData from '@/components/Tips/msgGuideTips.json';

export default {
  name: 'FormGuideTips',
  props: {
    nowStep: {
      type: Number,
      default: 1
    },
    selectLang: {
      type: String
    }
  },
  data() {
    return {
      nextText: '下一步',
      finishText: '完成',
      closeTipsText: '跳過教學'
    }
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'zh-CN'){
          this.nextText = '下一步';
          this.finishText = '完成';
          this.closeTipsText = '跳过教学';

          message = data[0].content_zh_CN;
        }
        if(this.selectLang == 'en-US'){
          this.nextText = 'next';
          this.finishText = 'finish';
          this.closeTipsText = 'skip teaching';

          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  methods: {
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    },
    closeTips() {
      this.$emit('closeTips');
    }
  }
};

</script>

<style lang="scss">
/*無效？*/
.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 999999;
}

.step701 {
  position: absolute;
  top: 15vh;
  left: 40vw;
}

.step702 {
  position: absolute;
  top: 40vh;
  left: 66vw;
}

.step703 {
  position: absolute;
  top: 45vh;
  left: 20vw;
}

.step704 {
  position: absolute;
  top: 33vh;
  left: 70vw;
}

.step705 {
  position: absolute;
  top: 50vh;
  left: 70vw;
}

.step706 {
  position: absolute;
  top: 50vh;
  left: 50vw;
}

.step707 {
  position: absolute;
  top: 30vh;
  left: 70vw;
}

.step708 {
  position: absolute;
  top: 50vh;
  left: 50vw;
}

.step709 {
  position: absolute;
  top: 50vh;
  left: 70vw;
}

.step710 {
  position: absolute;
  top: 55vh;
  left: 40vw;
}

.step711 {
  position: absolute;
  top: 55vh;
  left: 43vw;
}

.step712 {
  position: absolute;
  top: 45vh;
  left: 73vw;
}

.step713 {
  position: absolute;
  top: 45vh;
  left: 73vw;
}

/*.step714 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}*/

.step714 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step715 {
  position: absolute;
  top: 35vh;
  left: 73vw;
}

.step716 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step717 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step718 {
  position: absolute;
  top: 45vh;
  left: 70vw;
}

.step719 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step720 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step721 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step722 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step723 {
  position: absolute;
  top: 55vh;
  left: 43vw;
}

.step724 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step725 {
  position: absolute;
  top: 55vh;
  left: 43vw;
}

.step726 {
  position: absolute;
  top: 55vh;
  left: 43vw;
}

.step727 {
  position: absolute;
  top: 55vh;
  left: 43vw;
}

.step728 {
  position: absolute;
  top: 55vh;
  left: 43vw;
}

.step729 {
  position: absolute;
  top: 55vh;
  left: 43vw;
}

.step730 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step731 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step732 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step733 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step734 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step735 {
  position: absolute;
  top: 45vh;
  left: 53vw;
}

.tip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
